import debounce from "lodash.debounce";
import React, { useEffect, useState } from "react";
import {  useParams } from "react-router-dom";

import Box from "@mui/material/Box";

import IMSIResetList from "./IMSIResetList";
import Title from "../../../common/Title";

import { copyData } from "../../../../utils/copy";
import useAxios from "../../../../hooks/useAxios";
import { __getReset } from "../../../../api/sim";

const IMSIResetBatch = () => {
  const { batch_id } = useParams();
  const [data, setData] = useState([]);

  const [metaData, setMetaData] = useState({
    page: 1,
    page_size: 20000,
    total: 1,
  });
  const [response, call, loading] = useAxios({ ...__getReset });

  const debouncedFetchData = debounce((query) => {
    call(query);
  }, 500);

  useEffect(() => {
    debouncedFetchData({
      params: {
        page_size: 20000,
        batch_id: batch_id,
      },
    });

    return () => {
      debouncedFetchData.cancel();
    };
  }, []);

  useEffect(() => {
    if (response && response.status) {
      setMetaData({
        page: response.data.page,
        page_size: response.data.page_size,
        total: response.data.total,
      });
      setData(response.data.data);

    }
  }, [response]);


  return (
    <Box sx={{ width: "100%" }}>
      <Title
        variant="h5"
        content={`Reset Batch ID: ${batch_id}`}
        gutterBottom
      />
      {response ? (
        <>
          <IMSIResetList
            data={data}
            loading={loading}
            meta={{ ...metaData, page_size: 100 }}
            client={true}
            handleColumnClick={(key) => copyData(data, [key])}
          />
        </>
      ) : (
        <Title content="Please wait..." variant="subtitle2" gutterBottom />
      )}
    </Box>
  );
};

export default IMSIResetBatch;
